import http from "../tools/http";

export default {
  getOne(orgUUID, userUuid) {
    return http.get(`/organizations/${orgUUID}/users/${userUuid}`);
  },
  createAccessRequest(organizationUUID, reason) {
    return http.post(`/organizations/${organizationUUID}/access-requests`, { reason });
  },
  getTrackUsers() {
    return http.get("/track-users");
  },
  getAll(organizationUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/users`, { params: pagination });
  },
  getAllBlock(orgUUID, pagination) {
    return http.get(`/organizations/${orgUUID}/users/blocked`, { params: pagination });
  },
  delete(orgUUID, userUuid) {
    return http.delete(`/organizations/${orgUUID}/users/${userUuid}`);
  },
  block(orgUUID, userUUID) {
    return http.put(`/organizations/${orgUUID}/users/${userUUID}/block`);
  },
  unblock(orgUUID, userUUID) {
    return http.put(`/organizations/${orgUUID}/users/${userUUID}/unblock`);
  },
  getAllInvite(organizationUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/user-invites`, { params: pagination });
  },
  createInvite(organizationUUID, email, teamUUID) {
    return http.post(`/organizations/${organizationUUID}/user-invites`, {
      email: email,
      team_uuid: teamUUID
    });
  },
  deleteInvite(organizationUUID, userUUID) {
    return http.delete(`/organizations/${organizationUUID}/user-invites/${userUUID}`);
  },
  getAllRequested(organizationUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/access-requests`, { params: pagination });
  },
  updateAccessRequest(organizationUUID, accessRequestUUID, isApproved, teamUUID) {
    let data = { approved: isApproved ? 1 : 2, team_uuid: teamUUID };
    let endpoint = `${accessRequestUUID}/accept`;
    return http.patch(`/organizations/${organizationUUID}/access-requests/${endpoint}`, data);
  }
};
